module.exports = __webpack_public_path__ + "img/d-12.53444445.jpg";